import { render, staticRenderFns } from "./car.vue?vue&type=template&id=5cd0aef4&scoped=true&"
import script from "./car.vue?vue&type=script&lang=js&"
export * from "./car.vue?vue&type=script&lang=js&"
import style0 from "./car.vue?vue&type=style&index=0&lang=css&"
import style1 from "./car.vue?vue&type=style&index=1&id=5cd0aef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0aef4",
  null
  
)

export default component.exports